import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "../../_css/DeleteUserModal.module.css";
import {
  CustomButton,
  CustomButtonDanger,
  CustomButtonOutlineLight,
} from "../UI/CustomButtons";
import StarReviewEditable from "../common/StarReviewEditable";
import { ADD_REVIEW_MODAL } from "../../data/modelsData";
import { useSelector } from "react-redux";

const AddReviewModal = ({
  show,
  onHide,
  onSubmit,
  btnText = ["Maybe Later", "Save Review"],
  reviewData = {
    review: "",
    ratings: 0,
    review_id: null,
  },
}) => {
  const lang = useSelector((state) => state.language.lang);
  const { title, description, reviewLabel, reviewPlaceholder } =
    ADD_REVIEW_MODAL[lang];
  const [showRating, setShowRating] = useState(reviewData?.ratings || 0);
  const [reviewText, setReviewText] = useState(reviewData?.review || "");
  const [wordLimit] = useState(50);
  const [wordCount, setWordCount] = useState(0);

  // Helper function to count words
  const countWords = (text) => {
    if (!text || text.trim() === "") return 0;
    return text.trim().split(/\s+/).filter(word => word.length > 0).length;
  };

  useEffect(() => {
    setShowRating(reviewData?.ratings || 0);
    setReviewText(reviewData?.review || "");
    setWordCount(countWords(reviewData?.review || ""));
  }, [reviewData?.ratings, reviewData?.review]);

  useEffect(() => {
    if (!reviewData?.review) {
      resetStates();
    }
  }, []);

  const resetStates = () => {
    setShowRating(reviewData?.ratings || 0);
    setReviewText(reviewData?.review || "");
    setWordCount(countWords(reviewData?.review || ""));
  };

  const handleTextChange = (e) => {
    const newText = e.target.value;
    const newWordCount = countWords(newText);
    
    if (newWordCount <= wordLimit) {
      setReviewText(newText);
      setWordCount(newWordCount);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      style={{
        direction: lang == "ar" ? "rtl" : "ltr",
      }}
      className={styles.endSessionModal}
    >
      <Modal.Header className={styles.modalHeader} closeButton>
        <Modal.Title
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "var(--color-1)",
          }}
        >
          {reviewData?.review_id ? title : title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div>
          <div className={styles.ratingSection}>
            <div className={styles.ratingHeader}>
              <label className={styles.reviewLabel}>{description}</label>
              <span className={styles.ratingText}>{showRating}/5</span>
            </div>
            <i>
              <StarReviewEditable
                rating={showRating}
                onStarClick={(rating) => setShowRating(rating)}
                size={32}
                padding="6px"
              />
            </i>
          </div>
          <div className={`${styles.writeReviewSection} ${styles.reviewSection}`}>
            <div className={styles.reviewHeader}>
              <label className={styles.reviewLabel}> <strong>{reviewLabel} </strong> </label>
              <span 
                className={wordCount > wordLimit - 1 ? styles.wordCounterWarning : styles.wordCounter}
              >
                {wordCount}/{wordLimit} words
              </span>
            </div>
            <i>
              <textarea
                rows={4}
                placeholder={reviewPlaceholder}
                aria-expanded={false}
                value={reviewText}
                onChange={handleTextChange}
                style={{
                  borderColor: wordCount > wordLimit - 1 ? "#ff6b6b" : "#E3E6EA"
                }}
              />
            </i>
          </div>
        </div>
        <div className={styles.buttonRowContainer}>
          <CustomButtonOutlineLight
            text={btnText[0]}
            onClick={onHide}
            width="100%"
          />
          <CustomButton
            gap="8px"
            text={btnText[1]}
            onClick={() => onSubmit(reviewText, showRating)}
            width="100%"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddReviewModal;
